// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const InternalNetworkAdEntityKindSchema = z.enum(['USER','GROUP','COMPUTER','OU','DOMAIN','GPO','DOMAIN_CONTROLLER','CERT_TEMPLATE','CONTAINER'] as const);

export type InternalNetworkAdEntityKindType = `${z.infer<typeof InternalNetworkAdEntityKindSchema>}`

export default InternalNetworkAdEntityKindSchema;
